import { Component, Input, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ChartConfiguration, ChartOptions, ChartType } from "chart.js";
import { months, monthsNumeric } from "../../../../consts";
import { MonthModel } from "../../../../shared/components/table/month.model";
import { ActualSelected, Utils } from "../../../../shared/utils";
import { ResumeService } from "../../resume.service";
import { ResumeV2Model } from "../../resumeV2.model";
import { UntypedFormControl } from "@angular/forms";
import { chartPalette, gradientFill, tooltipBase, legendBase, barScalesBase, barGeometry } from "../chart-theme";

@Component({
    selector: 'chart-resume-igic',
    templateUrl: './chart-resume-igic.component.html',
    styleUrls: ['../../resume.component.css'],
    standalone: false
})
export class ChartResumeIgicComponent implements OnInit {
  @Input() showGlobal: boolean = false;
  @Input() dataV2: ResumeV2Model = new ResumeV2Model();

  totalIgic: number = 0;
  totalIncomesIgic: number = 0;
  totalExpensesIgic: number = 0;
  totalExpensesIgicImport: number = 0;
  totalInvestmentIgic: number = 0;

  monthControl = new UntypedFormControl(monthsNumeric);
  monthsSelected: string[];
  monthList: MonthModel[] = [];
  allMonthsSelected = false;

  public chartType: ChartType = 'bar';
  public chartData: ChartConfiguration<'bar'>['data'] = {
    labels: months,
    datasets: [
      { data: [], label: 'Impuestos Ingresos', backgroundColor: gradientFill(chartPalette.income), hoverBackgroundColor: chartPalette.income, ...barGeometry },
      { data: [], label: 'Impuestos Gastos', backgroundColor: gradientFill(chartPalette.expense), hoverBackgroundColor: chartPalette.expense, ...barGeometry }
    ]
  };
  public chartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 700, easing: 'easeOutQuart' },
    scales: barScalesBase(),
    plugins: { legend: legendBase(), tooltip: tooltipBase() }
  };

  constructor(
    private resumeService: ResumeService,
    public dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.setResumeData();
    this.resumeService.getDataSubject().subscribe(data => {
      if (!data) return;
      this.dataV2 = data.data;
      this.showGlobal = data.global;
      this.setResumeData();
    });
  }

  public chartClicked(e: any): void {}
  public chartHovered(e: any): void {}

  SetTotales() {
    this.totalIgic = Utils.GetValueWithDecimals(
      this.totalIncomesIgic - (this.totalExpensesIgic + this.totalExpensesIgicImport + this.totalInvestmentIgic)
    );
  }

  SetResumeIncomes() {
    this.totalIncomesIgic = Utils.GetValueWithDecimals(this.dataV2.incomesIgic?.[12]?.total || 0);
    if (this.dataV2.incomes != null && this.dataV2.expenses != null) this.SetTotales();
    this.setChartsData();
  }

  SetResumeExpenses() {
    this.totalExpensesIgic = Utils.GetValueWithDecimals(this.dataV2.expensesIgic?.[12]?.total || 0);
    this.totalInvestmentIgic = Utils.GetValueWithDecimals(this.dataV2.investmentIgic?.[12]?.total || 0);
    this.totalExpensesIgicImport = Utils.GetValueWithDecimals(this.dataV2.expensesIgicImport?.[12]?.total || 0);
    if (this.dataV2.incomes != null && this.dataV2.expenses != null) this.SetTotales();
    this.setChartsData();
  }

  setResumeData() {
    this.setMonths();
    this.SetResumeIncomes();
    this.SetResumeExpenses();
  }

  setMonths() {
    if (this.monthList.length === 0) {
      let i = 1;
      months.forEach(element => {
        const newMonth = new MonthModel();
        newMonth.name = element;
        newMonth.selected = true;
        newMonth.number = i.toString();
        this.monthList.push(newMonth);
        i += 1;
      });
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedResume = monthsNumeric;
    }
  }

  onChangeMonth(event) {
    this.monthsSelected = event.value;
    ActualSelected.monthSelectedResume = event.value;
    this.allMonthsSelected = false;
    this.monthList.forEach(element => element.selected = false);
    event.value.forEach(element => {
      this.monthList.find(f => f.number == element).selected = true;
    });
    this.updateValues();
  }

  onSelectAll(event) {
    if (event.checked) {
      this.allMonthsSelected = true;
      this.monthsSelected = monthsNumeric;
      ActualSelected.monthSelectedResume = monthsNumeric;
      this.monthControl.setValue(monthsNumeric, { emitEvent: false });
      this.monthList.forEach(element => element.selected = true);
    } else {
      this.allMonthsSelected = false;
      this.monthsSelected = [];
      ActualSelected.monthSelectedResume = [];
      this.monthControl.setValue([], { emitEvent: false });
      this.monthList.forEach(element => element.selected = false);
    }
    this.updateValues();
  }

  updateValues() {
    this.totalIncomesIgic = 0;
    this.totalExpensesIgic = 0;
    this.totalInvestmentIgic = 0;
    this.totalExpensesIgicImport = 0;

    this.monthsSelected.forEach(element => {
      const i = Number(element) - 1;
      this.totalIncomesIgic += this.dataV2.incomesIgic[i].total;
      this.totalExpensesIgic += this.dataV2.expensesIgic[i].total;
      this.totalExpensesIgicImport += this.dataV2.expensesIgicImport[i].total;
      this.totalInvestmentIgic += this.dataV2.investmentIgic[i].total;
    });

    this.totalIncomesIgic = Utils.GetValueWithDecimals(this.totalIncomesIgic);
    this.totalExpensesIgic = Utils.GetValueWithDecimals(this.totalExpensesIgic);
    this.totalInvestmentIgic = Utils.GetValueWithDecimals(this.totalInvestmentIgic);
    this.totalExpensesIgicImport = Utils.GetValueWithDecimals(this.totalExpensesIgicImport);
    this.totalIgic = Utils.GetValueWithDecimals(
      this.totalIncomesIgic - (this.totalExpensesIgic + this.totalExpensesIgicImport + this.totalInvestmentIgic)
    );

    this.setChartsData();
  }

  setChartsData() {
    const totalExpenseIgicChart: number[] = new Array(12).fill(0);
    for (let i = 0; i < Math.min(12, this.dataV2.expensesIgic?.length || 0); i++) {
      totalExpenseIgicChart[i] = Utils.GetValueWithDecimals(
        (this.dataV2.expensesIgic?.[i]?.total || 0) +
        (this.dataV2.investmentIgic?.[i]?.total || 0) +
        (this.dataV2.expensesIgicImport?.[i]?.total || 0)
      );
    }

    this.chartData = {
      labels: months,
      datasets: [
        {
          data: this.dataV2.incomesIgic?.slice(0, 12).map(a => a.total) ?? [],
          label: 'Impuestos Ingresos',
          backgroundColor: gradientFill(chartPalette.income),
          hoverBackgroundColor: chartPalette.income,
          ...barGeometry
        },
        {
          data: totalExpenseIgicChart,
          label: 'Impuestos Gastos',
          backgroundColor: gradientFill(chartPalette.expense),
          hoverBackgroundColor: chartPalette.expense,
          ...barGeometry
        }
      ]
    };
  }

  getSelectedMonthsNames(): string {
    const selectedNames = this.monthsSelected.map(index => this.monthList[parseInt(index) - 1].name);
    return selectedNames.join(', ');
  }
  public trackByIndex(i: number) { return i; }

}
